module.exports = {
      id: "Fb-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Fb-usage",
      toString: function () {
        return this.url;
      }
    }